import React from "react";
import { Link } from "react-router-dom";
import { Trans, withTranslation } from "react-i18next";
import img from "../../assets/images/complete.svg";
import bgSliders from "../../helpers/bgSliders";
import DjzSuccessPageDisplay from "./DjzSuccessPage.styled";
import "./DjzSuccessPage.scss";

const randomBg = bgSliders.getRandomBg();

function DjzSuccessPage({ t }) {
  return (
    <DjzSuccessPageDisplay className="" bgImg={randomBg}>
      <div className="formPage">
        <div className="formsLayout">
          <div className="header">
            <Link to="/">
              <div className="logo" />
            </Link>
          </div>
          <div className="center">
            <img src={img} alt="Complete" />
            <p className="message">
              <Trans>subscription_success</Trans>
            </p>
            <Link to="/" className="btn">
              <Trans>back_home</Trans>
            </Link>
          </div>
        </div>
      </div>
    </DjzSuccessPageDisplay>
  );
}

export default withTranslation()(DjzSuccessPage);
